// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604240719/js/" + chunkId + "." + {"44":"7d35f8c7","225":"5c096270","481":"4b4d2059","486":"90c3a0d8","770":"f7df7459"}[chunkId] + ".0.22167063058009706.chunk.js";
};